if (typeof module != 'undefined' && typeof require == 'function') {
    module.exports = require('./fittDOM.js');
}


//////////////////
// WEBPACK FOOTER
// ../~/espn-fitt/es5/fitt-dom/index.js
// module id = 807
// module chunks = 0